import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function GatewayBasicInfoComponent ({id,dbas,selectedGateway,handleInnerFormChange}: any) {
  const libraryData = useSelector(selectListItems)
 
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         {id=== '0' && 
        <InputContainer
       
                           label="DBA Name"
                           labelField="Name"
                           list={dbas}
                           onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PlatformDBAId',
                            )
                           }}
                           optionName="Choose DBA"
                           type="select"
                           value={selectedGateway?.PlatformDBAId}
                           valueField="Id"
                       />}
        {id!== '0' && 
        <InputContainer
        isDisabled
                           label="DBA Name"
                           labelField="Name"
                           list={dbas}
                           onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PlatformDBAId',
                            )
                           }}
                           optionName="Choose DBA"
                           type="select"
                           value={selectedGateway?.PlatformDBAId}
                           valueField="Id"
                       />}
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedGateway?.Name}
          />
          
         <InputContainer
                                   label="Type"
                                   labelField="Text"
                                   list={libraryData?.result?.DBAType}
                                   onValueChange={( newValue: any) => {
                                    const valueData: any = newValue.map((option: any) => option?.value)
                                    handleInnerFormChange(
                                     valueData,
                                     'Types'
                                   )
                                  }}
                                  type="multiselect"
                                   valueField="Text"
                                   value={selectedGateway?.Types}
                               />
          <InputContainer
              label="Url"
              name="Url"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Url',

                )
              }}
              type="text"
              value={selectedGateway?.Url}
          />
        
         <div className='col-span-full'>
        <InputContainer
       
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'Description',

              )
            }}
              type="rte"
            value={selectedGateway?.Description}
        /></div>
          
        </div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}